const BOT_PROTECTION_ERROR_CODES = new Set([
  'BOT_PROTECTION_REQUIRED',
  'BOT_PROTECTION_FAILED',
  'BOT_PROTECTION_UNAVAILABLE',
]);

export function isBotProtectionError(error: unknown): boolean {
  if (error instanceof Error && BOT_PROTECTION_ERROR_CODES.has(error.message)) return true;
  if (!(error instanceof ApiError) || typeof error.details !== 'object' || error.details === null) return false;
  const code = (error.details as Record<string, unknown>).code;
  return typeof code === 'string' && BOT_PROTECTION_ERROR_CODES.has(code);
}
import { ApiError } from '../types/errors';
